import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Contributor.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
export type ContributorType = {
  _id: string;
  image: SanityImageObject;
  displayImage?: boolean;
  name: string;
  first_name?: string; // Optional first name for display purposes
  email?: string;
  subrole?: string;
  additional?: string;
};
export const Contributor: React.FC<ContributorType & {
  contactLink?: boolean;
  locale?: string;
}> = t0 => {
  const $ = _c(21);
  const {
    image,
    displayImage: t1,
    name,
    first_name,
    email,
    subrole,
    additional,
    contactLink: t2,
    locale: t3
  } = t0;
  const displayImage = t1 === undefined ? true : t1;
  const contactLink = t2 === undefined ? false : t2;
  const locale = t3 === undefined ? "no" : t3;
  let contactString;
  if (locale === "no") {
    contactString = "Ta kontakt med";
  } else {
    if (locale === "dk") {
      contactString = "Tag kontakt med";
    } else {
      if (locale === "sv") {
        contactString = "Ta kontakt med";
      } else {
        contactString = "Contact ";
      }
    }
  }
  let t4;
  if ($[0] !== displayImage || $[1] !== image) {
    t4 = image != null && displayImage && <div className={styles.contributor__image}><ResponsiveImage layout="cover" image={image} sizes="90vw 240px 160px" /></div>;
    $[0] = displayImage;
    $[1] = image;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== name) {
    t5 = <span className={styles.contributor__title}>{name}</span>;
    $[3] = name;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = subrole ?? "";
  let t7;
  if ($[5] !== t6) {
    t7 = <span className={styles.contributor__subrole + " detailheader"}>{t6}</span>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = additional ?? "";
  let t9;
  if ($[7] !== t8) {
    t9 = <span className={styles.contributor__additional + " detailheader"}>{t8}</span>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== contactLink || $[10] !== contactString || $[11] !== email || $[12] !== first_name || $[13] !== name) {
    t10 = contactLink ? <a href={`mailto:${email}`}><span className={styles.contributor__email + " caption"}>→ {contactString}<span className={styles.contributor__email_name}>{" "}{first_name ? first_name : name.split(" ")[0]}</span></span></a> : <span className={styles.contributor__email + " caption"}>{email ?? ""}</span>;
    $[9] = contactLink;
    $[10] = contactString;
    $[11] = email;
    $[12] = first_name;
    $[13] = name;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t4 || $[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
    t11 = <div className={styles.contributor}>{t4}{t5}{t7}{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};